import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import StatisticsByRefererTable from './StatisticsByRefererTable.js';
import {
    mainSelector,
    getHeaderName,
    getMetrics,
    getKeysMetric,
    getRowsCount
} from './StatisticsByRefererTable.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    data: mainSelector,
    headerName: getHeaderName,
    metrics: getMetrics,
    keysMetric: getKeysMetric,
    rowsCount: getRowsCount
});

const StatisticsByRefererTableComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            loading: state.statistics.data.loading
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
        };
    }
)(StatisticsByRefererTable);

export default StatisticsByRefererTableComponent;
